export const AllEventColoumnData = {
    "name": "",
    "type": "event",
    "csv": false,
    "xlsx": false,
    "current": false,
    "columns": [
        {
            "id": "nom_vp",
            "style": {
                "minWidth": "83px"
            },
            "width": 83,
            "content": "Name",
            "renderInView": true
        },
         {
            "id": "group",
            "style": {
                "minWidth": "83px"
            },
            "width": 83,
            "content": "Group",
            "renderInView": true
        },
        {
            "id": "dealership",
            "width": 120,
            "content": "Dealership",
            "renderInView": true,
            "style": {
                "minWidth": "120px"
            }
        },
        {
            "id": "package",
            "width": 100,
            "showIf": true,
            "content": "Package",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "start_date",
            "style": {
                "minWidth": "125px"
            },
            "width": 125,
            "content": "Start Date",
            "renderInView": true
        },
        {
            "id": "end_date",
            "width": 125,
            "content": "End Date",
            "renderInView": true,
            "style": {
                "minWidth": "125px"
            }
        },
        {
            "id": "clients",
            "width": 80,
            "showIf": true,
            "content": "Active",
            "renderInView": true,
            "style": {
                "minWidth": "80px"
            }
        },
        {
            "id": "inactive",
            "style": {
                "minWidth": "55px"
            },
            "width": 80,
            "showIf": true,
            "content": "Inactive",
            "renderInView": true
        },
        {
            "id": "conquest",
            "style": {
                "minWidth": "55px"
            },
            "width": 100,
            "showIf": true,
            "content": "Conquest",
            "renderInView": true
        },
        {
            "id": "amount",
            "width": 100,
            "showIf": true,
            "content": "Amount",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "sales_rep",
            "width": 120,
            "content": "Representative",
            "renderInView": true,
            "style": {
                "minWidth": "120px"
            }
        },
        {
            "id": "brand",
            "width": 100,
            "content": "Brand",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "project_manager",
            "width": 100,
            "content": "Project Manager",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "confirmation_agent",
            "width": 160,
            "content": "Confirmation Agent",
            "renderInView": true,
            "style": {
                "minWidth": "160px"
            }
        },
        {
            "id": "no_show_agent",
            "width": 160,
            "content": "No Show Agent",
            "renderInView": true,
            "style": {
                "minWidth": "160px"
            }
        },
        {
            "id": "carton",
            "width": 100,
            "content": "Carton",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "mailing",
            "width": 100,
            "content": "Mailing",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "massif",
            "width": 100,
            "content": "Massive",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "web",
            "width": 100,
            "content": "Web",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "banner",
            "width": 100,
            "content": "Banner",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "news_letter",
            "width": 100,
            "content": "Newsletter",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "facebook",
            "width": 100,
            "content": "Facebook",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "ad_words",
            "width": 100,
            "content": "Adwords",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "sms",
            "width": 100,
            "content": "SMS",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "invoice",
            "width": 100,
            "content": "Invoice",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "amount_animator",
            "width": 100,
            "content": "Amount Animator",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "invoice_animator",
            "width": 100,
            "content": "Invoice Animator",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "commission_paid",
            "width": 100,
            "content": "Commission Paid",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "call_centre",
            "width": 100,
            "content": "Call Centre",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "instructions",
            "width": 100,
            "content": "Instructions",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "mailing_amount",
            "width": 100,
            "content": "Mailing Amount",
            "renderInView": true,
            "style": {
                "minWidth": "100px"
            }
        },
        {
            "id": "animator",
            "width": 150,
            "content": "Event Manager",
            "renderInView": true,
            "style": {
                "minWidth": "150px"
            }
        },
        {
            "id": "fidgi_contest",
            "width": 150,
            "content": "Fidgi Contest",
            "renderInView": true,
            "style": {
                "minWidth": "150px"
            }
        },
        {
            "id": "created_by",
            "width": 150,
            "content": "Created By",
            "renderInView": true,
            "style": {
                "minWidth": "150px"
            }
        },
        {
            "id": "actions",
            "style": {
                "right": 0,
                "position": "sticky",
                "minWidth": "100px"
            },
            "width": 100,
            "showIf": true,
            "colSpan": 5,
            "content": "Actions",
            "className": "text-center",
            "renderInView": true
        }
    ]
}

export const AllClientColoumnData = {
    // "id": 1607,
    // "user_id": 1,
    "name": "Default View",
    "columns": [
        {
            "id": "id",
            "style": [],
            "width": 40,
            "content": "ID",
            "className": "text-center",
            "renderInView": true
        },
        {
            "id": "prospect_type",
            "width": 170,
            "content": "Prospect Type",
            "minWidth": "150px",
            "renderInView": true
        },
        {
            "id": "prospect_source",
            "width": 185,
            "content": "Prospect Source",
            "minWidth": "165px",
            "renderInView": true
        },
        {
            "id": "first_name",
            "style": {
                "minWidth": "100px"
            },
            "width": 120,
            "content": "First Name",
            "renderInView": true
        },
        {
            "id": "last_name",
            "style": {
                "minWidth": "language === \"en\" ? \"100px\" : \"135px\""
            },
            "width": 165,
            "content": "Last Name",
            "renderInView": true
        },
        {
            "id": "phone",
            "style": {
                "minWidth": "language === \"en\" ? \"130px\" : \"180px\""
            },
            "width": 200,
            "content": "Phone Number",
            "renderInView": true
        },
        {
            "id": "office_phone",
            "style": {
                "minWidth": "language === \"en\" ? \"130px\" : \"155px\""
            },
            "width": 185,
            "content": "Office Number",
            "renderInView": true
        },
        {
            "id": "email",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Email",
            "renderInView": true
        },
        {
            "id": "og_rep",
            "style": {
                "overflow": "hidden",
                "whiteSpace": "nowrap",
                "textOverflow": "ellipsis"
            },
            "width": 150,
            "content": "Representative",
            "renderInView": true
        },
        {
            "id": "call_status",
            "width": 150,
            "content": "Call Status",
            "renderInView": true
        },
        {
            "id": "make",
            "width": 100,
            "content": "Make",
            "renderInView": true
        },
        {
            "id": "model",
            "width": 100,
            "content": "Model",
            "renderInView": true
        },
        {
            "id": "year",
            "style": {
                "minWidth": "language === \"en\" ? \"95px\" : \"90px\""
            },
            "width": 90,
            "content": "Year",
            "renderInView": true
        },
        {
            "id": "general_comment",
            "style": {
                "minWidth": "language === \"en\" ? \"180px\" : \"230px\""
            },
            "width": 90,
            "content": "General Comment",
            "renderInView": true
        },
        {
            "id": "km",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "KM",
            "renderInView": true
        },
        {
            "id": "address",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Address",
            "renderInView": true
        },
        {
            "id": "city",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "City",
            "renderInView": true
        },
        {
            "id": "province",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Province",
            "renderInView": true
        },
        {
            "id": "postal_code",
            "style": {
                "minWidth": 150
            },
            "width": 150,
            "content": "Postal Code",
            "renderInView": true
        },
        {
            "id": "appointment",
            "style": {
                "minWidth": "language === \"fr\" ? 150 : 100"
            },
            "width": 100,
            "content": "Appointment",
            "renderInView": true
        },
        {
            "id": "mobile_phone",
            "style": {
                "minWidth": 150
            },
            "width": 150,
            "content": "Mobile Number",
            "renderInView": true
        },
        {
            "id": "language",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Language",
            "renderInView": true
        },
        {
            "id": "vin",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "VIN",
            "renderInView": true
        },
       
        {
            "id": "purchase_date",
            "style": {
                "minWidth": 150
            },
            "width": 150,
            "content": "Purchase Date",
            "renderInView": true
        },
        {
            "id": "last_service_date",
            "style": {
                "minWidth": "language === \"fr\" ? 180 : 150"
            },
            "width": 150,
            "content": "Last Service Date",
            "renderInView": true
        },
         {
            "id": "maturity_date",
            "width": 125,
            "content": "Maturity Date",
            "renderInView": true,
            "style": {
                "minWidth": "125px"
            }
        },
        {
            "id": "greetings",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Greetings",
            "renderInView": true
        },
        {
            "id": "confirmation_status",
            "style": {
                "minWidth": "language === \"en\" ? \"170px\" : \"195px\""
            },
            "width": 225,
            "content": "Confirmation Status",
            "renderInView": true
        },
        {
            "id": "confirmation_notes",
            "style": {
                "minWidth": "language === \"en\" ? \"165px\" : \"195px\""
            },
            "width": 225,
            "content": "Confirmation Notes",
            "renderInView": true
        },
        {
            "id": "visit_status",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 255,
            "content": "Visit Status",
            "renderInView": true
        },
        {
            "id": "visit_notes",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 255,
            "content": "Visit Notes",
            "renderInView": true
        },
        {
            "id": "no_show_status",
            "style": {
                "minWidth": "language === \"en\" ? \"170px\" : \"195px\""
            },
            "width": 225,
            "content": "No Show Status",
            "renderInView": true
        },
        {
            "id": "no_show_notes",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 255,
            "content": "No Show Notes",
            "renderInView": true
        },
        {
            "id": "appointment_rep_user_name",
            "style": {
                "minWidth": "language === \"en\" ? \"280px\" : \"295px\""
            },
            "width": 260,
            "content": "Appointment Representative",
            "renderInView": true
        },
        {
            "id": "appointment_time",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 255,
            "content": "Appointment Time",
            "renderInView": true
        },
        {
            "id": "appointment_date",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 255,
            "content": "Appointment Date",
            "renderInView": true
        },
        {
            "id": "appointment_comment",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 255,
            "content": "Appointment Comment",
            "renderInView": true
        },
        {
            "id": "import_note",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 255,
            "content": "Import Note",
            "renderInView": true
        },
        {
            "id": "group_code",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 255,
            "content": "Group Code",
            "renderInView": true
        },
        {
            "id": "create_by",
            "style": {
                "minWidth": "language === \"en\" ? \"220px\" : \"255px\""
            },
            "width": 180,
            "content": "Booked By",
            "renderInView": true
        },
        {
            "id": "actions",
            "style": {
                "right": 0,
                "position": "-webkit-sticky"
            },
            "width": 100,
            "colSpan": 3,
            "content": "Actions",
            "className": "text-center",
            "renderInView": true
        }
    ],
    "current": "1",
    "xlsx": "1",
    "csv": "1",
    "type": "default client",
    // "updated_at": "2025-06-02T16:34:42.000000Z",
    // "created_at": "2025-06-02T21:34:42.000000Z"
}

export const AllAppointmentsColoumnData = {
    // "id": 1617,
    // "user_id": 1,
    "name": "Default View",
    "columns": [
        {
            "id": "full_name",
            "style": [],
            "width": 160,
            "content": "Full Name",
            "className": "text-center",
            "renderInView": true
        },
        {
            "id": "phone",
            "style": {
                "minWidth": "130px"
            },
            "width": 150,
            "content": "Phone Number",
            "renderInView": true
        },
        {
            "id": "email",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Email",
            "renderInView": true
        },
        {
            "id": "prospect_type",
            "style": [],
            "width": 145,
            "content": "Prospect Type",
            "minWidth": "145px",
            "renderInView": true
        },
        {
            "id": "prospect_source",
            "style": [],
            "width": 160,
            "content": "Prospect Source",
            "minWidth": "140px",
            "renderInView": true
        },
        {
            "id": "visit_status",
            "style": {
                "minWidth": "220px"
            },
            "width": 150,
            "content": "Visit Status",
            "renderInView": true
        },
        {
            "id": "visit_notes",
            "style": {
                "minWidth": "220px"
            },
            "width": 150,
            "content": "Visit Notes",
            "renderInView": true
        },
        {
            "id": "general_comment",
            "style": {
                "minWidth": "220px"
            },
            "width": 220,
            "content": "General Comment",
            "renderInView": true
        },
        {
            "id": "call_status",
            "style": [],
            "width": 150,
            "content": "Call Status",
            "renderInView": true
        },
        {
            "id": "model",
            "style": [],
            "width": 100,
            "content": "Model",
            "renderInView": true
        },
        {
            "id": "year",
            "style": {
                "minWidth": "95px"
            },
            "width": 95,
            "content": "Year",
            "renderInView": true
        },
        {
            "id": "appointment_date",
            "style": {
                "minWidth": "220px"
            },
            "width": 220,
            "content": "Appointment Date",
            "renderInView": true
        },
        {
            "id": "appointment_time",
            "style": {
                "minWidth": "220px"
            },
            "width": 190,
            "content": "Appointment Time",
            "renderInView": true
        },
        {
            "id": "appointment_rep_user_name",
            "style": {
                "minWidth": "280px"
            },
            "width": 260,
            "content": "Appointment Representative",
            "renderInView": true
        },
        {
            "id": "appointment_comment",
            "style": {
                "minWidth": "220px"
            },
            "width": 220,
            "content": "Appointment Comment",
            "renderInView": true
        },
        {
            "id": "confirmation_status",
            "style": {
                "minWidth": "170px"
            },
            "width": 190,
            "content": "Confirmation Status",
            "renderInView": true
        },
        {
            "id": "confirmation_notes",
            "style": {
                "minWidth": "165px"
            },
            "width": 195,
            "content": "Confirmation Notes",
            "renderInView": true
        },
        {
            "id": "no_show_status",
            "style": {
                "minWidth": "170px"
            },
            "width": 170,
            "content": "No Show Status",
            "renderInView": true
        },
        {
            "id": "no_show_notes",
            "style": {
                "minWidth": "220px"
            },
            "width": 150,
            "content": "No Show Notes",
            "renderInView": true
        },
        {
            "id": "address",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Address",
            "renderInView": true
        },
        {
            "id": "city",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "City",
            "renderInView": true
        },
        {
            "id": "province",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Province",
            "renderInView": true
        },
        {
            "id": "postal_code",
            "style": {
                "minWidth": 150
            },
            "width": 150,
            "content": "Postal Code",
            "renderInView": true
        },
        {
            "id": "office_phone",
            "style": {
                "minWidth": "130px"
            },
            "width": 150,
            "content": "Office Number",
            "renderInView": true
        },
        {
            "id": "mobile_phone",
            "style": {
                "minWidth": 150
            },
            "width": 150,
            "content": "Mobile Number",
            "renderInView": true
        },
        {
            "id": "language",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Language",
            "renderInView": true
        },
        {
            "id": "vin",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "VIN",
            "renderInView": true
        },
        {
            "id": "purchase_date",
            "style": {
                "minWidth": 150
            },
            "width": 150,
            "content": "Purchase Date",
            "renderInView": true
        },
        {
            "id": "maturity_date",
            "style": {
                "minWidth": 150
            },
            "width": 150,
            "content": "Maturity Date",
            "renderInView": true
        },
        {
            "id": "last_service_date",
            "style": {
                "minWidth": "220px"
            },
            "width": 180,
            "content": "Last Service Date",
            "renderInView": true
        },
        {
            "id": "km",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "KM",
            "renderInView": true
        },
        {
            "id": "og_rep",
            "style": {
                "overflow": "hidden",
                "whiteSpace": "nowrap",
                "textOverflow": "ellipsis"
            },
            "width": 150,
            "content": "Representative",
            "renderInView": true
        },
        {
            "id": "create_by",
            "style": {
                "minWidth": "220px"
            },
            "width": 120,
            "content": "Booked By",
            "renderInView": true
        },
        {
            "id": "greetings",
            "style": {
                "minWidth": 100
            },
            "width": 100,
            "content": "Greetings",
            "renderInView": true
        },
        {
            "id": "actions",
            "style": {
                "right": 0,
                "position": "sticky"
            },
            "width": 100,
            "colSpan": 3,
            "content": "Actions",
            "className": "text-center",
            "renderInView": true
        }
    ],
    "current": "0",
    "xlsx": "1",
    "csv": "1",
    "type": "default appointment",
    // "updated_at": "2025-06-03T12:38:54.000000Z",
    // "created_at": "2025-06-03T17:38:54.000000Z"
}